import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const getPopupContentStyle = (isMobile: boolean) => ({
  width: '100%',
  height: isMobile ? '100%' : 'auto',
  maxWidth: isMobile ? 'none' : '700px',
  maxHeight: isMobile ? 'none' : '700px',
  padding: '1.5rem 1rem 1.375rem',
  overflowY: 'auto',
});

export const ListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  min-height: 400px;
  margin-top: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => `${theme.borders.xs} ${theme.colors.primary.variant5}`};
  border-radius: ${({ theme }) => theme.radius.sm};
`;

export const ListItemStyled = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0 0.25rem 0.5rem;
  background: ${({ theme }) => theme.colors.primary.variant3};
  margin: 0.25rem 0.5rem;
  border-radius: ${({ theme }) => theme.radius.xs};

  &:first-of-type {
    margin-top: 0.5rem;
  }
  &:last-of-type {
    margin-bottom: 0.5rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 0.75rem 0 0.75rem 0.5rem;
    }
  `}
`;

export const AttachmentNameStyled = styled(Typography)`
  max-width: 80px;
  width: 100%;
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.primary.variant11};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 6px;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      max-width: 160px;
    }
  `}

  ${({ theme }) => `
    ${theme.devices.tablet} {
      max-width: 200px;
    }
  `}
`;

export const TitleStyled = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.variant8};
`;

export const TypographyStyled = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
`;

export const BtnStyled = styled(Button)`
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  &:disabled {
    opacity: 1;
  }

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.colors.secondary.variant5};
    }
  }
`;

export const FlexStyled = styled(FlexContainer)`
  height: 100%;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      height: 354px;
    }
  `}
`;
